import { Icon, Sidebar } from '@primer-io/goat';
import { ChevronRight, ChevronDown } from '@primer-io/goat-icons';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import styles from '../AppLayout.module.scss';
import { SidebarLinkProps } from './types';

type SidebarMainItemProps = PropsWithChildren<
  Omit<SidebarLinkProps, 'to' | 'childrenLinks' | 'children'>
> & {
  href?: string;
  isActive: boolean;
  isDisabled: boolean;
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  customIconSize?: boolean;
};

export function SidebarMainItem({
  href,
  label,
  icon,
  iconActive,
  isActive,
  isDisabled,
  children,
  isChild,
  isOpen,
  setIsOpen,
  customIconSize = true,
  ...rest
}: SidebarMainItemProps) {
  const iconElement = (
    <Icon
      as={isActive ? iconActive : icon}
      className={customIconSize ? styles.navIconSize : undefined}
    />
  );

  if (href) {
    return (
      <Sidebar.Item
        as={Link}
        to={href}
        active={isActive}
        disabled={isDisabled || undefined}
        {...rest}
      >
        {iconElement}
        {label}
        {children}
      </Sidebar.Item>
    );
  }

  return (
    <Sidebar.Item
      active={isActive}
      disabled={isDisabled || undefined}
      onClick={() => setIsOpen(!isOpen)}
      {...rest}
    >
      {!isChild && iconElement}
      {label}
      {!isChild && (
        <>
          {children}
          <Icon
            className={customIconSize ? styles.navIconSize : undefined}
            as={isOpen ? ChevronDown : ChevronRight}
          />
        </>
      )}
    </Sidebar.Item>
  );
}
